/**
 * Application configuration constants
 * Shared across both borrower and lender applications
 */

// Session timeout in milliseconds (30 minutes)
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

// Session check interval in milliseconds (1 minute)
export const SESSION_CHECK_INTERVAL_MS = 60000;

// Google Drive API scopes
export const GOOGLE_DRIVE_SCOPES = [
  "https://www.googleapis.com/auth/drive",
  "https://www.googleapis.com/auth/drive.metadata.readonly",
  "https://www.googleapis.com/auth/userinfo.email",
  "https://www.googleapis.com/auth/userinfo.profile",
  "openid",
].join(" ");

// File processing batch size
export const FILE_BATCH_SIZE = 10;

// Maximum content length for file preview (characters)
export const MAX_CONTENT_PREVIEW_LENGTH = 4000;

// Supported file MIME types
export const SUPPORTED_MIME_TYPES = {
  GOOGLE_DOC: "application/vnd.google-apps.document",
  PDF: "application/pdf",
  TEXT: "text/plain",
  FOLDER: "application/vnd.google-apps.folder",
};

// File upload constants
export const MAX_FILE_SIZE_MB = 25;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// Upload progress constants
export const UPLOAD_PROGRESS_THRESHOLD = 80; // Percentage before showing as complete
export const UPLOAD_PROGRESS_INTERVAL_MS = 150;

// Pagination constants
export const DOCUMENTS_PAGE_SIZE = 10;
export const COMMENTS_PAGE_SIZE = 10;

// Time constants
export const MILLISECONDS_PER_DAY = 86400000;
export const SIGNED_URL_TTL_MS = 5 * 60 * 1000; // 5 minutes

// API delay for mock responses
export const API_MOCK_DELAY_MS = 400;

// UI timeout constants
export const STATUS_UPDATE_DELAY_MS = 200;

// Environment configuration
export const CONFIG = {
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  },
  google: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  },
  openai: {
    apiKey: process.env.REACT_APP_OPENAI_API_KEY,
    model: process.env.REACT_APP_OPENAI_MODEL || "gpt-4o",
  },
  app: {
    underwriterEmail: process.env.REACT_APP_UNDERWRITER_EMAIL,
    // Use empty string in development to leverage proxy, full URL in production
    pdfApiUrl: process.env.NODE_ENV === 'production'
      ? (process.env.REACT_APP_PDF_API_URL || "http://localhost:8000")
      : "",
  },
};



